// ハンバーガーメニュー
const trigger = document.getElementById('menu-trigger');
const overlay = document.getElementById('menu-overlay');
const body = document.body;
trigger.addEventListener('click', () => {
    body.classList.toggle('menu-open');
});
overlay.addEventListener('click', () => {
    body.classList.remove('menu-open');
});


// headerの高さを取得してmain上の余白を設定
const header = document.querySelector('header');
const main = document.querySelector('main');
function adjustMainPadding() {
    if (!header || !main) return; // エラー防止：要素がない場合は何もしない
    const headerHeight = header.offsetHeight;
    main.style.paddingTop = headerHeight + 'px';
}
window.addEventListener('load', adjustMainPadding);
window.addEventListener('resize', adjustMainPadding);

